import { Accordion, AccordionSummary, Badge } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

interface Props {
  hasError?: boolean;
}

const BadgeMandatoryWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-right",
}));

const BadgeMandatory = styled(Badge)(() => ({
  backgroundColor: "#FEF3F2",
  color: "#D92D20",
  padding: "4px 8px",
  borderRadius: 4,
}));

const SummaryContent = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
}));

const StepWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 10,
}));

const StepNumber = styled("div")(() => ({
  height: 32,
  width: 32,
  border: `1.5px solid #1D2939`,
  borderRadius: 100,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 16,
  "& > span": {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "20px",
    letterSpacing: 0.1,
    color: "#1D2939",
    fontFamily: "Manrope",
  },
}));

const TitleWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  padding: "16px 12px",
}));

const Title = styled("span")(() => ({
  fontSize: 22,
  fontWeight: 700,
  lineHeight: "28px",
  fontFamily: "Manrope",
  color: "#1D2939",
}));

const Subtitle = styled("span")(() => ({
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "24px",
  fontFamily: "Manrope",
  color: "#475467",
}));

const Divider = styled("div")(() => ({
  width: "100%",
  height: 1,
  backgroundColor: "#E4E7EC",
  marginTop: 0,
}));

const AccordionWrapper = styled(Accordion)(({ hasError = false }: Props) => ({
  border: `1px solid ${hasError ? colors.error600 : colors.gray200}`,
  borderRadius: "12px !important",
  boxShadow: "none !important",
  "&:not(:first-child)": {
    marginTop: "32px !important",
  },
  "&:not(:last-child)": {
    marginBottom: 5,
  },
  "&::before": {
    height: "0px !important",
  },
}));

const AccordionMandatoryError = styled("div")(() => ({
  height: 32,
  width: "100%",
  padding: "8px 16px",
  gap: 8,
  display: "flex",
  alignItems: "center",
  alignSelf: "stretch",
  backgroundColor: colors.error50,
  borderRadius: "12px 12px 4px 4px",
  "& > span": {
    fontFamily: "Manrope",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: 0.5,
    color: colors.error600,
  },
}));

const AccordionSummaryWrapper = styled(AccordionSummary)(() => ({
  height: "88px !important",
}));

export const AccordionTag = {
  Wrapper: AccordionWrapper,
  Summary: AccordionSummaryWrapper,
  Mandatory: {
    Wrapper: BadgeMandatoryWrapper,
    Badge: BadgeMandatory,
  },
  Content: SummaryContent,
  Step: {
    Divider,
    Wrapper: StepWrapper,
    Number: StepNumber,
    TitleWrapper,
    Title,
    Subtitle,
    Error: AccordionMandatoryError,
  },
};
